const Italy = () => {
  return (
    <>
      <h1 className='text-3xl text-center font-semibold mb-36'>
        Informativa privacy
      </h1>

      <div className='package'>
        <p>
          Ai sensi e per gli effetti di cui agli articoli 13 e ss. del
          Regolamento UE n. 2016/679, riguardo ai dati personali forniti che
          formeranno oggetto di trattamento, si informa l’interessato di quanto
          segue:
        </p>
      </div>

      <div className='package'>
        <h4>Titolare e responsabili del trattamento</h4>
        <p>
          Il titolare del trattamento è la società SMART SERVICES S.R.L., in
          persona del legale rappresentante p.t., con sede legale in 20154 –
          Milano (MI), Via Pola n. 11, C.F. e P. IVA n.{' '}
          <a href='tel:12220580968'>12220580968</a>, p.e.c.
          <a href='mailto:smart.services@legalmail.it'>
            smart.services@legalmail.it
          </a>
          , e-mail{' '}
          <a href='mailto:amministrazione@smartcaf.it'>
            amministrazione@smartcaf.it
          </a>
          .. Il trattamento è effettuato tramite il portale
          <a href='https://www.smartcaf.it/'>https://www.smartcaf.it/</a>,
        </p>
        <p>
          A decorrere dal 25.5.2018, per effetto dell’entrata in vigore del
          Regolamento UE n. 2016/679, le aziende ed i professionisti i quali
          forniscono agli interessati i preventivi richiesti, e i successivi
          servizi/forniture, assumono il ruolo e la responsabilità di
          contitolari del trattamento dei dati personali degli utenti. A tal
          fine, Smart Services S.r.l. fa sottoscrivere a ciascuna
          azienda/professionista una specifica assunzione di responsabilità ed
          impegno al rispetto dei diritti degli interessati, in materia di
          trattamento dei relativi dati personali. L’elenco completo dei
          contitolari del trattamento è disponibile presso il titolare del
          trattamento, a semplice richiesta dell’interessato.
        </p>
      </div>

      <div className='package'>
        <h4>Responsabile della protezione dei dati personali (DPO)</h4>
        <p>
          Smart Services S.r.l., a seguito dell’entrata in vigore del
          Regolamento UE n. 2016/679, pur non essendone obbligata, ha effettuato
          una sommaria valutazione di impatto privacy, dalla quale è emersa
          l’insussistenza di trattamenti particolarmente pericolosi e/o di
          rischio elevato. Inoltre, non sussistono – allo stato – i requisiti
          dimensionali, né si effettua monitoraggio regolare e sistematico degli
          interessati (su larga scala) e le attività principali del titolare o
          del responsabile del trattamento non consistono nel trattamento su
          larga scala di categorie particolari di dati personali e di dati
          relativi a condanne penali e/o a reati.
        </p>
      </div>

      <div className='package'>
        <h4>Finalità del trattamento</h4>
        <p>
          I dati personali da forniti dal Cliente verranno trattati per le
          seguenti finalità: a. esecuzione del contratto; b. adempimenti di
          legge di natura fiscale e previdenziale; c. attività volte a favorire
          l’incontro tra domanda e offerta di servizi legati al marketing e alla
          comunicazione. La base giuridica del trattamento si fonda sul sulla
          legge nonché sul consenso, libero, esplicito, specifico, informato ed
          inequivocabile al trattamento dei dati personali dell’interessato,
          espresso da quest’ultimo sulla base della presente Informativa
          Privacy.
        </p>
      </div>

      <div className='package'>
        <h4>
          Modalità del trattamento e categorie dei destinatari dei dati
          personali
        </h4>
        <p>
          Attraverso il portale{' '}
          <a href='https://www.smartcaf.it/'>https://www.smartcaf.it/</a> gli
          interessati forniscono alcuni dati personali (nome, cognome, indirizzo
          e-mail, numero di telefono, ed altri dati personali), che Smart
          Services S.r.l. si impegna a trattare per il perseguimento delle
          finalità di cui al paragrafo precedente.
        </p>
        <p>
          Il trattamento viene eseguito mediante strumenti informatici e/o
          telematici, e consiste in qualsiasi operazione o insieme di
          operazioni, compiute con o senza l’ausilio di processi automatizzati e
          applicabile a dati personali o insiemi di dati personali forniti
          dall’interessato. I dati forniti saranno conservati su supporti
          magnetici o cartacei, sempre nel rispetto dei requisiti di sicurezza
          previsti dalla legge. I dati personali forniti potranno essere
          trattati per le finalità di cui sopra, anche a mezzo telefax, SMS ed
          altri sistemi informatici e/o automatizzati di trasmissione e
          comunicazione. Smart Services S.r.l. si impegna a non utilizzare i
          dati segnalati come inesatti sino a quando l’inesattezza non sia stata
          rettificata.
        </p>
      </div>

      <div className='package'>
        <h4>Consenso al trattamento dei dati personali</h4>
        <p>
          L’interessato è libero di conferire o meno i suoi dati personali,
          fermo restando che Smart Services S.r.l. si riserva il diritto di non
          accettare richieste di preventivi che non siano accompagnate dagli
          elementi indispensabili per consentire l’identificazione e il
          successivo contatto dell’interessato, con ciò comportando
          l’impossibilità di usufruire dei servizi di richieste.it, di
          instaurare nuovi rapporti, di concludere contratti e di eseguire le
          prestazioni richieste. I servizi offerti da Smart Services S.r.l., e
          dalle aziende/professionisti che collaborano con Smart Services
          S.r.l., si rivolgono ad un pubblico di utenti di età superiore a 16
          anni.
        </p>
      </div>

      <div className='package'>
        <h4>Comunicazione e diffusione dei dati</h4>
        <p>
          Oltre che alla categoria delle aziende e dei professionisti, come
          sopra individuata, i dati personali forniti possono essere comunicati
          a dipendenti, consulenti esterni, commercialisti, legali, istituti di
          credito, società di servizi e di consulenza, ad Aziende speciali della
          Camera di commercio ed alla Camera di Commercio stessa. Nell’ambito
          della propria attività Smart Services S.r.l. potrà comunicare i dati
          forniti anche: – a terzi soggetti, incaricati dell’esecuzione di
          attività direttamente connesse e strumentali all’erogazione dei
          servizi di richieste.it con i quali l’Azienda abbia stipulato accordi
          commerciali funzionali alla diffusione ed allo sviluppo dei servizi da
          erogare, dei quali è disponibile una lista dettagliata su espressa
          richiesta dell’interessato; – altre società che offrono beni e/o
          servizi appartenenti a categorie merceologiche pubblicizzate
          attraverso la rete Internet, con le quali Smart Services S.r.l. abbia
          stipulato accordi commerciali. I dati personali forniti non sono
          soggetti a diffusione.
        </p>
      </div>

      <div className='package'>
        <h4>Trasferimento dei dati personali all’estero</h4>
        <p>
          I dati personali potranno essere trasferiti verso paesi dell’Unione
          Europea e verso i paesi terzi rispetto all’Unione Europea, qualora ciò
          si renda necessario per l’esecuzione di obblighi derivanti da un
          contratto del quale è parte l’interessato o per adempiere, prima della
          conclusione del contratto, a specifiche richieste dell’interessato,
          ovvero per la conclusione o l’esecuzione di un contratto stipulato a
          favore dell’interessato, ovvero negli altri casi previsti dall’art. 13
          del Regolamento UE n. 2016/679, previa sottoscrizione di specifiche
          clausole contrattuali modello.
        </p>
      </div>

      <div className='package'>
        <h4>
          Criteri utilizzati per la determinazione del periodo di conservazione
          dei dati dell’interessato.
        </h4>
        <p>
          Smart Services S.r.l. utilizzerà i dati personali forniti
          dall’interessato per il periodo di tempo necessario alla corretta
          esecuzione degli obblighi contrattuali assunti nei confronti di
          quest’ultimo, e in relazione alla tempistica di esecuzione del
          servizio/fornitura prestato dal professionista/azienda. La tempistica
          di conservazione del dato è diversificata a seconda dello specifico
          trattamento (prestazione del servizio, finalità statistiche, finalità
          di marketing) come analiticamente descritto nel “registro dei
          trattamenti”, adottato e costantemente aggiornato da Smart Services
          S.r.l., e disponibile presso il Titolare del trattamento, a semplice
          richiesta dell’interessato.
        </p>
      </div>

      <div className='package'>
        <h4>Diritti dell’interessato.</h4>
        <p>
          Gli articoli 13 e ss. del Regolamento UE n. 2016/679, conferiscono
          all’interessato il diritto: di ottenere la conferma dell’esistenza o
          meno dei dati personali che lo riguardano, anche se non ancora
          registrati, e la loro comunicazione in forma intelligibile; di
          ottenere l’indicazione dell’origine dei dati personali; di ottenere
          l’indicazione delle finalità e modalità di trattamento; di ottenere
          l’indicazione degli estremi identificativi del titolare del
          trattamento dei dati; di ottenere l’indicazione dei soggetti o delle
          categorie di soggetti ai quali i dati personali possono essere
          comunicati; di ottenere l’aggiornamento, la rettificazione ovvero,
          quando vi ha interesse, l’integrazione dei dati; di ottenere la
          cancellazione, la trasformazione in forma anonima o il blocco dei dati
          trattati in violazione di legge, compresi quelli di cui non è
          necessaria la conservazione in relazione agli scopi per i quali i dati
          sono stati raccolti o successivamente trattati; di ottenere
          l’attestazione che le operazioni di cui ai due paragrafi che precedono
          sono state portate a conoscenza, anche per quanto riguarda il loro
          contenuto, di coloro ai quali i dati sono stati comunicati o diffusi,
          eccettuato il caso in cui tale adempimento si riveli impossibile o
          comporti un impiego di mezzi manifestamente sproporzionato rispetto al
          diritto tutelato; di opporsi in tutto o in parte, per motivi
          legittimi, al trattamento dei dati personali che lo riguardano,
          ancorché pertinenti allo scopo della raccolta.
        </p>
        <p>Si informa altresì l’interessato che:</p>
        <ul>
          <li>
            Ha diritto di richiedere al titolare del trattamento l’accesso ai
            dati personali e la rettifica o la cancellazione degli stessi o la
            limitazione del trattamento che lo riguardano o di opporsi al loro
            trattamento, oltre al diritto alla portabilità dei dati;
          </li>
          <li>
            Ha diritto di revocare il consenso prestato, ai sensi degli articoli
            6, par. 1, lett. a), oppure art. 9, par. 2, lett. a), in relazione
            al trattamento dei dati personali che lo riguardano, e che tale
            diritto può essere esercitato in qualsiasi momento, senza che sia
            pregiudicata la liceità del trattamento basata sul consenso prestato
            prima della revoca;
          </li>
          <li>Ha diritto di proporre reclamo all’autorità di controllo;</li>
          <li>
            Ha libertà di rifiutare la comunicazione dei propri dati personali
            al titolare, il quale può – a sua volta – rifiutare la prestazione
            del servizio offerto da Smart Services S.r.l. solo qualora i dati
            trasmessi siano insufficienti ad individuare il soggetto richiedente
            o il servizio/fornitura richiesti;
          </li>
          <li>
            Smart Services S.r.l. effettua, sulla base dei dati personali che
            vengono trasmessi dagli interessati, alcuni processi decisionali
            automatizzati, compresa la profilazione di cui all’art. 22,
            paragrafi 1 e 4 del Regolamento UE n. 2016/679. In tali casi la
            logica utilizzata da Smart Services S.r.l. è la seguente: i dati
            personali degli utenti potranno essere aggregati per categorie di
            richiesta di preventivo, ovvero per provenienza territoriale delle
            richieste, ovvero per tipologia di richiedente, al fine di
            ottimizzare i servizi offerti, ed eventualmente inviare
            comunicazioni pubblicitarie personalizzate. Ciò comporta, per
            l’interessato, la possibilità che vengano ricavate, anche in via
            automatica, informazioni riguardanti le caratteristiche, la
            frequenza, e l’ubicazione dei servizi/forniture richieste tramite il
            portale https://www.smartcaf.it/. L’interessato ha diritto ad
            opporsi al trattamento (art. 21 del Regolamento UE) e a non essere
            sottoposto a una decisione basata unicamente sul trattamento
            automatizzato, compresa la profilazione, ed a ottenere – su propria
            richiesta – l’intervento umano da parte del titolare del
            trattamento, nonché il diritto di esprimere la propria opinione e di
            contestare la decisione (art. 22 del Regolamento UE);
          </li>
          <li>
            Ha diritto a ricevere la notificazione di violazione dei dati
            personali, in caso di rischio elevato per i diritti
            dell’interessato.
          </li>
        </ul>
        <p>
          I dati forniti potranno essere verificati a richiesta presso Smart
          Services S.r.l. e potranno essere aggiornati e/o rettificati, ovvero
          potrà essere richiesta una limitazione di trattamento, a mezzo e-mail
          da inviare al seguente indirizzo di posta elettronica:
          amministrazione@smartcaf.it. Con lo stesso mezzo potrà essere chiesta
          la cancellazione dei dati personali forniti (diritto all’oblio – art.
          17 del Regolamento UE n. 2016/679).
        </p>
        <p>
          Smart Services S.r.l., e le aziende/professionisti che riceveranno le
          richieste di preventivi tramite il portale richieste.it, declinano
          ogni responsabilità per l’eventualità che il Cliente non risulti
          titolare dei dati e/o delle informazioni comunicateci, ovvero non
          abbia la facoltà di comunicarli o diffonderli, così come per
          inesattezze degli stessi.
        </p>
        <p>
          Preso atto dell’informativa sopra riportata, avente ad oggetto il
          trattamento dei dati personali effettuato da Smart Services S.r.l.,
          l’interessato può liberamente acconsentire:
        </p>
        <p>
          1) al suddetto trattamento dei dati personali, sia comuni sia
          sensibili, che mi riguardano, per le finalità e con le modalità –
          anche automatizzate – indicate nell’informativa e alla comunicazione
          degli stessi alle categorie di soggetti ivi indicate;
        </p>
        <p>
          2) a che mi vengano inviati anche a mezzo di sistemi automatizzati di
          chiamata senza l’intervento di un operatore, e quindi anche a mezzo di
          posta elettronica, di telefax, SMS ecc. materiali pubblicitari e
          comunicazioni commerciali relativamente a qualsiasi evento, attività
          e/o servizio promossi o posti in essere, potendo peraltro oppormi in
          seguito a tale utilizzo.
        </p>
      </div>
    </>
  )
}

export default Italy